import React, { ElementType, ReactNode, useMemo } from 'react';
import { HTMLMotionProps, motion } from 'framer-motion';

export type TAnimatePeekProps<T extends ElementType> = Omit<React.ComponentPropsWithoutRef<T>, 'children'> &
    Omit<HTMLMotionProps<'div'>, 'children'> & {
        component?: T;
        children?: ReactNode;
        amount?: number;
        x?: boolean;
    };
export const AnimatePeek = <T extends ElementType>({
    children,
    x,
    amount = 10,
    style,
    component,
    ...props
}: TAnimatePeekProps<T>) => {
    const direction = x ? 'x' : 'y';
    const value = x ? -amount : amount;

    const Component = useMemo(() => {
        if (!component) {
            return motion.div;
        }
        return motion.create(component);
    }, [component]);

    return (
        <Component
            initial={{ opacity: 0, [direction]: value }}
            animate={{ opacity: 1, [direction]: 0 }}
            exit={{ opacity: 0, [direction]: value }}
            style={{ display: component ? undefined : 'flex', ...style }}
            {...props}
        >
            {children}
        </Component>
    );
};
